<template>
  <div class="rewrite-sections-smoke">
    <div
      class="rewrite-sections-smoke__bar"
      aria-hidden="true"
    />
    <v-container fluid>
      <ArticleChatShell
        mode="goal"
        flow="analyze"
        improve-goal="rewrite"
        :asking="false"
        :value="topic"
        :url="url"
        :keyword="keyword"
        :loaded-title="topic"
        :loaded-headings="headings"
        :history-rows="historyRows"
        :section-uids="sectionUids"
        @sections="sectionUids = $event"
      />
    </v-container>
  </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import ArticleChatShell from '@/components/articleChat/ArticleChatShell.vue';
    import {I18n} from '@/plugins/I18n';
    import type {HistoryRow, LoadedHeading} from '@/service/articleChatSetup';

    /** Layout fixture for the path B rewrite step: 9 H2 checkboxes under the real shell. */
    export default Vue.extend({
        name: 'RewriteSectionsSmokeView',
        components: {ArticleChatShell},
        beforeCreate() {
            I18n.locale = 'cs';
        },
        data: () => ({
            topic: 'Kreatin pro začátečníky',
            url: 'https://www.vasweb.cz/clanek',
            keyword: 'kreatin',
            headings: [
                {level: 1, text: 'Kreatin pro začátečníky'},
                {level: 2, text: 'Dávkování kreatinu'},
                {level: 2, text: 'Nežádoucí účinky'},
                {level: 2, text: 'Kreatin a voda'},
                {level: 2, text: 'Druhy kreatinu'},
                {level: 2, text: 'Kreatin před tréninkem'},
                {level: 2, text: 'Kreatin po tréninku'},
                {level: 2, text: 'Kreatin a kofein'},
                {level: 2, text: 'Jak dlouho užívat kreatin'},
                {level: 2, text: 'Kreatin pro ženy'},
            ] as LoadedHeading[],
            sectionUids: [] as string[],
            historyRows: [
                {id: 'url', step: 1, title: 'Adresa článku', value: 'https://www.vasweb.cz/clanek'},
                {id: 'loaded', step: 2, title: 'Načtená stránka', value: 'Kreatin pro začátečníky'},
                {id: 'topic', step: 3, title: 'Téma', value: 'Kreatin pro začátečníky'},
                {id: 'locale', step: 4, title: 'Stát a jazyk', value: 'Česko · čeština'},
                {id: 'keyword', step: 5, title: 'Klíčové slovo', value: 'kreatin'},
                {id: 'template', step: 6, title: 'Šablona', value: 'Univerzální'},
                {id: 'style', step: 7, title: 'Styl', value: 'Odborný'},
            ] as HistoryRow[],
        }),
    });
</script>

<style lang="sass" scoped>
.rewrite-sections-smoke
    padding-top: 64px

.rewrite-sections-smoke__bar
    position: fixed
    top: 0
    left: 0
    right: 0
    height: 64px
    background: #0566c3

@media (max-width: 959px)
    .rewrite-sections-smoke
        padding-top: 56px

    .rewrite-sections-smoke__bar
        height: 56px
</style>
